import { create } from 'zustand';
export interface IShopMeta {
  key: string;
  value: string;
}
export interface IShopMetaStore {
  shopMeta?: IShopMeta[];
  isQueryShopMetaDefault: boolean;
  setShopMeta: (shopMeta: IShopMeta[]) => void;
  removeShopMeta: (keys: string[]) => void;
  setIsQueryShopMetaDefault: (isQueryShopMetaDefault: boolean) => void;
}

export const useShopMetaStore = create<IShopMetaStore>()((set, get) => ({
  shopMeta: undefined,
  isQueryShopMetaDefault: false,
  setShopMeta: (data) => {
    const currentShopMeta = get().shopMeta?.filter((item) => !data.find((d) => d.key === item.key));
    const newShopMeta = [...(currentShopMeta || []), ...data];
    set({ shopMeta: newShopMeta });
  },
  removeShopMeta: (keys) => {
    set({ shopMeta: get().shopMeta?.filter((item) => !keys.includes(item.key)) });
  },
  setIsQueryShopMetaDefault: (isQueryShopMetaDefault) => set({ isQueryShopMetaDefault }),
}));

export default useShopMetaStore;
